import React, { CSSProperties } from 'react'
import { useNavigate } from 'react-router-dom'
import Button2 from '@embracesbs/component-button2'
import Icon from '@embracesbs/component-icon'
import SearchField from './SearchField'
import SectionHeader from '../../Common/SectionHeader'
import { Filters, SetFilters } from '../../../Interfaces/Types'

interface HeaderProps {
  query: string
  setQuery: (query: string) => void
  filters: Filters
  setFilters: SetFilters
}

const wrapStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  marginBottom: '12px',
  // The column's content wrapper has no right padding (the list scrollbar
  // sits flush against the edge), so the header adds its own.
  paddingRight: '12px',
  flexShrink: 0
}

const searchRowStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px'
}

const Header: React.FC<HeaderProps> = ({ query, setQuery, filters, setFilters }) => {
  const navigate = useNavigate()
  const onlyWithTenants = filters.showSubscriptionsWithTenant

  const toggleWithTenants = () => {
    setFilters({
      ...filters,
      showSubscriptionsWithTenant: !onlyWithTenants,
      showSubscriptionsWithoutTenant: false
    })
  }

  return (
    <div style={wrapStyle}>
      <SectionHeader title='Subscriptions' />
      <div style={searchRowStyle}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <SearchField query={query} setQuery={setQuery} />
        </div>
        <Button2
          style={{ borderRadius: '8px', flexShrink: 0 }}
          leftElement={<Icon iconName='Filter1' size={16} color={onlyWithTenants ? '#ffffff' : '#416eec'} />}
          onClick={toggleWithTenants}
          text=''
          tooltip={
            onlyWithTenants
              ? 'Showing only subscriptions with tenants — click to show all'
              : 'Showing all subscriptions — click to show only those with tenants'
          }
          type='button'
          variant={onlyWithTenants ? 'contained' : 'outlined'}
        />
      </div>
      {query && (
        <Button2
          leftElement={<Icon iconName='Search' size={16} />}
          rightElement={<Icon iconName='ArrowRight1' size={14} />}
          onClick={() => navigate(`/search?q=${encodeURIComponent(query)}`)}
          text={`Search "${query}" in Advanced search`}
          isFullWidth
          type='button'
          variant='outlined'
        />
      )}
    </div>
  )
}

export default Header
